module.exports = __webpack_public_path__ + "static/media/ban.29849335.svg";